import { render, staticRenderFns } from "./appAlert.vue?vue&type=template&id=65d66785&scoped=true"
import script from "./appAlert.vue?vue&type=script&lang=js"
export * from "./appAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d66785",
  null
  
)

export default component.exports